module.exports = __webpack_public_path__ + "img/fast-donator.4e9bb6b9.png";